<script>
const columns = [
    {
        key: 'no',
        align: 'center',
        title: 'No',
        width: 60,
        scopedSlots: { customRender: 'number' }
    }, {
        key: 'kpi',
        align: 'center',
        width: 300,
        title: 'Sasaran Kompetensi',
        scopedSlots: { customRender: 'kpi' }
    }, {
        title: 'Informasi',
        children: [
            {
                key: 'internal',
                title: 'Internal',
                width: 200,
                align: 'center',
                scopedSlots: { customRender: 'internal' }
            }, {
                key: 'external',
                title: 'External',
                width: 200,
                align: 'center',
                scopedSlots: { customRender: 'external' }
            }
        ]
    }, {
        key: 'level',
        align: 'center',
        width: 100,
        title: 'Req. Level',
        scopedSlots: { customRender: 'level' }
    }, {
        key: 'weight',
        align: 'center',
        title: 'Bobot (%)',
        width: 80,
        scopedSlots: { customRender: 'weight' }
    }, {
        key: 'rating',
        align: 'center',
        title: 'Level Pencapaian Competency',
        scopedSlots: { customRender: 'rating' }
    }, {
        key: 'final',
        align: 'center',
        title: 'Nilai Akhir',
        width: 100,
        scopedSlots: { customRender: 'final' }
    }
]
const Competency = {
    id: null,
    index: null,
    number: null,
    is_heading: false,
    is_footer: false,
    level: 0,
    period: null,
    rating: 0,
    note_1: null,
    note_2: null,
    name: '',
    weight: 0,
    hash: '',
}

export default {
    props: {
        user_hash: {
            type: String,
            required: true
        },
        period: {
            type: String,
            required: true
        }
    },
    computed: {
        totalScore() {
            return this.items.reduce((a,b) => a + (b.weight / 100) * b.rating, 0).toFixed(2)
        },
        isMentor() {
            return this.$laravel.roles.performance === "mentor"
        },
    },
    data: () => ({
        columns,
        loading: false,
        submitting: false,
        objectives: [],
        items: [],
        filters: {
            month: null
        }
    }),
    created() {
        this.getObjectives()
    },
    methods: {
        buildData() {
            let idx = 0,collection = [], heading = 0, number = 0, vm = this
            this.objectives.forEach(function(item,index) {
                idx++
                if (heading !== item.perspective.name ) {
                    collection.push(Object.assign(Object.create(Competency), {
                        id: idx,
                        number,
                        is_heading: true,
                        name: item.perspective.name,
                    }))
                    number = 0
                    heading = item.perspective.name
                    idx++
                }

                let score = item.scores.length > 0 ? item.scores[0].breakdown['raw_score_' + vm.moment(vm.period, 'YYYY-MM').format('YYYYMM')] : 0
                let internal = item.scores.length > 0 ? item.scores[0].note_1 : ''
                let external = item.scores.length > 0 ? item.scores[0].note_2 : ''
                number++
                collection.push(Object.assign(Object.create(Competency), {
                    id: idx,
                    index,
                    hash: item.hash,
                    number,
                    period: vm.moment(vm.period, 'YYYY-MM').format('YYYYMM'),
                    rating: score,
                    name: item.objective,
                    internal: internal || '',
                    external: external || '',
                    level: item.config.min_achievement,
                    weight: item.config.weight * 100,
                }))
            })

            collection.push(Object.assign(Object.create(Competency), {
                id: idx + 1,
                is_footer: true,
                name: 'Total',
                weight: collection.reduce((a, b) => a + b.weight, 0),
            }))
            this.items =  collection
        },
        handleSuccessResponse(data) {
            this.objectives = data.objectives
            this.buildData()

            this.loading = false
        },
        getObjectives() {
            this.loading = true
            this.$http
                .get(this.routeUri('api.performance.implementation'), {
                    params: {
                        cat: 'PRF-SOC',
                        user: this.user_hash
                    }
                })
                .then(r => this.handleSuccessResponse(r.data))
                .catch(err => this.handleXhrError(err))
        },
        submit() {
            let filtered = _.filter(this.items, (o) => o.rating === 0 && o.is_heading === false  && o.is_footer === false)

            if (filtered.length > 0) {
                this.notify({
                    key: 'submitting',
                    type: 'error',
                    title: 'Data Incomplete',
                    message: 'Level Pencapaian Competency harus terisi',
                });
            } else {
                this.showConfirm()
            }
        },
        handleSubmit() {
            this.submitting = true
            this.$http.post(this.routeUri('api.performance.soft-competency.store'), {
                user: this.user_hash,
                objectives: this.items
            })
                .then((r) => this.notify({
                    key: 'submitting',
                    type: 'success',
                    title: 'Success',
                    message: 'Data has been saved!'
                }))
                .catch(err => this.handleXhrError(err))
                .finally(() => this.submitting = false)
        },
        showConfirm() {
            let msg = 'Anda yakin akan melakukan penilaian?'
            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.handleSubmit()
                },
                onCancel() {},
                class: 'test',
            });
        },
        back() {
            window.location.href = this.routeUri('admin.performance.scoring.soft-competency', { user: this.user_hash})
        },
    }
}
</script>
<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Penilaian Soft Competency" @back="back">
            <br>
            <common-user-header :user_hash="user_hash"/>
        </a-page-header>
        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :dataSource="items" :columns="columns" rowKey="id" :pagination="false"  :rowClassName="(r) => r.is_heading || r.is_footer ? 'row-heading' : (r.rating === 0 ? 'border-danger' : 'border-success')">
                    <div slot-scope="r" slot="number" class="text-center text-small" v-show="! r.is_heading">
                        <strong>{{ r.number }}</strong>
                    </div>

                    <div slot-scope="r" slot="kpi" class="text-small text-left">
                        <template v-if="r.is_heading || r.is_footer === true ">
                            <strong>{{ r.name }}</strong>
                        </template>
                        <template v-else>
                            {{ r.name }}
                        </template>
                    </div>

                    <div slot="internal" slot-scope="r" class="text-align: center;" v-show="! r.is_heading  && ! r.is_footer">
                        <div style="width: 100%">
                            <a-input v-model="r.internal" :readOnly="!isMentor" />
                        </div>
                    </div>

                    <div slot="external" slot-scope="r" class="text-align: center;" v-show="! r.is_heading  && ! r.is_footer">
                        <div style="width: 100%">
                            <a-input v-model="r.external" :readOnly="!isMentor" />
                        </div>
                    </div>

                    <div slot="level" slot-scope="r" class="text-align: center;" v-show="! r.is_heading  && ! r.is_footer" >
                        <strong>{{ r.level }}</strong>
                    </div>

                    <div slot-scope="r" slot="weight" class="text-small text-center" v-show="! r.is_heading ">
                        <strong>{{ r.weight }}%</strong>
                    </div>

                    <div slot="rating" slot-scope="r" class="text-align:center;" v-show="! r.is_heading && ! r.is_footer">
                    <span>
                        <a-rate v-model="r.rating" :tooltips="['1','2','3','4','5']" :disabled="!isMentor" />
                        <span class="ant-rate-text"><strong> {{ r.rating }}</strong></span>
                    </span>
                    </div>

                    <div slot-scope="r" slot="final" class="text-small text-center" v-show="! r.is_heading">
                        <template v-if="r.is_footer">
                            <strong>{{ totalScore }}</strong>
                        </template>
                        <template v-else>
                            <strong>{{ parseFloat((r.weight / 100) * r.rating).toFixed(2) }}</strong>
                        </template>
                    </div>
                </a-table>
            </a-skeleton>
            <div style="margin-top: 24px;" class="text-right" v-if="isMentor">
                <a-button type="primary" :disabled="submitting" :loading="submitting" @click="submit">Submit</a-button>
            </div>
        </a-card>
    </div>
</template>
